module.exports = __webpack_public_path__ + "media/svg-new/icon-ingles-e6a1c4c7.svg";